// extracted by mini-css-extract-plugin
module.exports = {"description":"category-public-description_description__vimOP","quickTip":"category-public-description_quickTip__4XrWh","tipLabel":"category-public-description_tipLabel__7A0OX"};